import React from "react";
import {
  CardContainer,
  TopSection,
  AnswerIcon,
  AnswerInput,
  TextInputFrame,
  QuestionText,
  StyledButton,
  ButtonText,
  ButtonIcon,
} from "./styles";
import { BOOK_A_DEMO_URL } from "../../../../lib/constants";

const TitleCard = () => {
  return (
    <CardContainer>
      <TopSection>
        <AnswerIcon />
        <AnswerInput>
          <TextInputFrame>
            <QuestionText>
              Hi, I'm Reach. <br />
              How can I help you?
            </QuestionText>
          </TextInputFrame>
          <StyledButton href={BOOK_A_DEMO_URL}>
            <ButtonText>Join Us</ButtonText>
            <ButtonIcon />
          </StyledButton>
        </AnswerInput>
      </TopSection>
    </CardContainer>
  );
};

export default TitleCard;
